function loadItems(triggerElement) {
  // 核心：找到觸發元素所屬的「父層容器」(例如 .collection)。
  // 這樣就能確保無論頁面上有多少個商品列表，它只會抓自己區域內的數據，不互相干擾。
  const parentContainer = triggerElement.closest('.collection') || document;

  const totalPagesInput = parentContainer.querySelector("[data-total-pages]");
  const currentPageInput = parentContainer.querySelector("[data-current-page]");
  const nextUrlInput = parentContainer.querySelector("[data-next-url]");

  // 確保數據存在才執行，避免報錯
  if (!totalPagesInput || !currentPageInput || !nextUrlInput) {
    console.warn("Load more data inputs missing in this scope.");
    return;
  }

  const totalPages = parseInt(totalPagesInput.value, 10);
  let currentPage = parseInt(currentPageInput.value, 10);
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const rawValue = nextUrlInput.value;

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set("page", pageValue);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  };

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);
  const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);

  // 更新隱藏的當前頁數
  currentPageInput.value = currentPage;

  triggerElement.setAttribute("disabled", "");
  triggerElement.classList.add("loading");

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");
      
      const newGrid = doc.querySelector(".load-more-grid");
      // 同理，只找這個父層容器裡面的 grid 把商品塞進去
      const wrapper = parentContainer.querySelector(".load-more-grid");
      
      if (!newGrid || !wrapper) {
        throw new Error("Grid element not found");
      }
      
      const newItems = newGrid.innerHTML;
      wrapper.insertAdjacentHTML("beforeend", newItems);

      // 進度條與計數器也改為區域內更新
      if (doc.getElementById("LoadMoreProgress") || doc.querySelector("#LoadMoreProgress")) {
        updateProgressLabel(responseHTML, parentContainer);
        updateProgressbar(currentPage, totalPages, parentContainer);
      }
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      triggerElement.removeAttribute("disabled");
      triggerElement.classList.remove("loading");
    })
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = parentContainer.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const scopedNextUrlInput = scrollData.querySelector("input[data-next-url]");
          const scopedCurrentPageInput = scrollData.querySelector("input[data-current-page]");

          if (scopedNextUrlInput) {
            scopedNextUrlInput.dataset.nextUrl = nextUrlScroll;
            scopedNextUrlInput.value = nextUrlScroll;
          }

          if (scopedCurrentPageInput) {
            scopedCurrentPageInput.dataset.currentPage = currentPage;
            scopedCurrentPageInput.value = currentPage;
          }

          checkVisibility();
        }

        triggerElement.removeAttribute("disabled");
        triggerElement.classList.remove("loading");

        // 如果已經載入到最後一頁，就把按鈕移除
        if (currentPage === totalPages) {
          triggerElement.remove();
        }
      }
    });
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function updateProgressLabel(html, parentContainer) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const countEl = doc.getElementById("LoadMoreProgress") || doc.querySelector("#LoadMoreProgress");
  const count = countEl ? countEl.innerHTML : "";
  
  // 優先從當前的容器找
  const container = parentContainer ? parentContainer.querySelector("#LoadMoreProgress") : document.getElementById("LoadMoreProgress");
  if (container) {
    container.innerHTML = count;
  }
}

function updateProgressbar(current, total, parentContainer) {
  // 優先從當前的容器找
  const progressbar = parentContainer ? parentContainer.querySelector("#LoadMoreProgressBar") : document.getElementById("LoadMoreProgressBar");
  if (progressbar) {
    progressbar.style.width = `${(current / total) * 100}%`;
  }
}

function initLoadMore() {
  // 只初始化無限滾動，一般點擊按鈕交由事件代理處理
  checkVisibility();
}

// 事件代理 (Event Delegation)：綁定在 document 上。
// 這樣就算是透過 ajax 動態塞進來 (例如 double-menu) 的按鈕，點擊也能生效！
document.addEventListener('click', function(event) {
  const button = event.target.closest('.js-load-more');
  
  if (button) {
    event.preventDefault();
    // 確保按鈕不是正在 loading 或 disabled 狀態
    if (!button.hasAttribute('disabled') && !button.classList.contains('loading')) {
      loadItems(button);
    }
  }
});

(function () {
  initLoadMore();
})();